import React from 'react'
import styled from 'styled-components'
import { Colors } from '@styles/colors'
import { useHistory, useParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '@store/selectors/utils'
import { setSamsungTerms } from '@store/modules/samsungTermsSlice'

const Wrapper = styled.section`
  flex-direction: column;
  padding: 0 24px 16px;
  display: flex;
  flex: 1;
  height: 100%;
`
const Contents = styled.article`
  display: flex;
  flex: 1;
  flex-direction: column;
`
const Title = styled.h2`
  color: ${Colors.bg_dark};
  line-height: 29px;
  font-size: 24px;
  letter-spacing: -0.72px;
  font-family: Pretendard700, sans-serif;
  margin-bottom: 40px;
`
const ListBox = styled.ul`
  background-color: #eaeef3;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`
const Item = styled.li`
  font-size: 16px;
  line-height: 120%;
  font-family: Pretendard400, sans-serif;
  color: ${Colors.bg_dark};
`
const Caption = styled.p`
  font-size: 14px;
  line-height: 120%;
  font-family: Pretendard400, sans-serif;
  color: #999ba9;
  margin: 32px 0;
`
const BottomButton = styled.button`
  outline: none;
  font-size: 16px;
  line-height: 120%;
  font-family: Pretendard400, sans-serif;
  width: 100%;
  height: 56px;
  color: ${Colors.gf};
  background-color: #0e6dfb;
  border-radius: 12px;
`
const BoldText = styled.p`
  font-family: Pretendard700, sans-serif;
  font-size: 16px;
  line-height: 120%;
`
const Header = styled.header`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 56px;
  margin-bottom: 24px;
  & > button {
    padding: 0;
  }
`
const PrivacyTermsComponent = () => {
  return (
    <>
      <Contents>
        <Title>개인정보 수집 및 제공 동의</Title>
        <ListBox>
          <Item>
            수집하는 개인정보 항목:
            <br />
            <BoldText>이름, 전화번호, 계좌번호</BoldText>
          </Item>
          <Item>
            수집 이용 목적:
            <br />
            <BoldText>
              이벤트 대상자 확인, 경품 지급, 재산상이익제공 정보 등록
            </BoldText>
          </Item>
          <Item>
            보유 및 이용 기간:
            <br />
            <BoldText>이용 목적 완료 시, 즉시 파기</BoldText>
          </Item>
        </ListBox>
        <Caption>
          * 개인정보의 수집 및 이용에 대한 동의를 거부할 수 있으며, 이 경우
          이벤트 참여가 제한됩니다.
        </Caption>
      </Contents>
    </>
  )
}
const ThirdPartyComponent = () => {
  return (
    <>
      <Contents>
        <Title>개인정보 제3자 제공 동의</Title>
        <ListBox>
          <Item>
            제공받는 자:
            <br />
            <BoldText>삼성증권</BoldText>
          </Item>
          <Item>
            제공하는 항목:
            <br />
            <BoldText>이름, 전화번호, 계좌번호</BoldText>
          </Item>
          <Item>
            제공받는 자의 이용 목적:
            <br />
            <BoldText>
              이벤트 대상자 확인, 경품 지급, 재산상이익제공 정보 등록
            </BoldText>
          </Item>
          <Item>
            제공받는 자의 보유 및 이용 기간:
            <br />
            <BoldText>이용 목적 완료 시, 즉시 파기</BoldText>
          </Item>
        </ListBox>
        <Caption>
          * 개인정보의 제3자 제공에 대한 동의를 거부할 수 있으며, 이 경우 이벤트
          참여가 제한됩니다.
        </Caption>
      </Contents>
    </>
  )
}
interface Params {
  type: 'privacy' | 'thirdParty'
}
const TermsPage = () => {
  const params: Params = useParams()
  const dispatch = useAppDispatch()
  const termsState = useAppSelector((state) => state.samsungTermsReducer)
  const history = useHistory()
  const handleBack = () => {
    history.goBack()
  }

  const onClickAgree = () => {
    switch (params.type) {
      case 'privacy': {
        dispatch(
          setSamsungTerms({
            ...termsState,
            privacy: true,
          })
        )
        break
      }

      case 'thirdParty': {
        dispatch(
          setSamsungTerms({
            ...termsState,
            thirdParty: true,
          })
        )
        break
      }
      default: {
        return null
      }
    }
    handleBack()
  }

  return (
    <Wrapper>
      <Header>
        <button onClick={handleBack}>
          <img
            src={'/icons/only_x_black.png'}
            alt={'close'}
            width={24}
            height={24}
          />
        </button>
      </Header>
      {params.type === 'privacy' ? (
        <PrivacyTermsComponent />
      ) : params.type === 'thirdParty' ? (
        <ThirdPartyComponent />
      ) : null}
      <BottomButton onClick={onClickAgree}>동의</BottomButton>
    </Wrapper>
  )
}
export default TermsPage
